/* global Swiper, attachEvent */
const topSliderElements = document.querySelectorAll('[data-slider="product-gallery__top-slider"]');
const bottomSliderElements = document.querySelectorAll('[data-slider="product-gallery__bottom-slider"]');

const setWrapperStyles = function (swiper) {
  const wrapperCenterClass = 'swiper-wrapper__center';
  const buttonDisabledClass = swiper.params.navigation.disabledClass;
  const [wrapperEl] = swiper.$wrapperEl;

  const addWrapperClass = swiper.navigation.$nextEl[0].classList.contains(buttonDisabledClass)
    && swiper.navigation.$prevEl[0].classList.contains(buttonDisabledClass);

  wrapperEl.classList.toggle(wrapperCenterClass, addWrapperClass);
};

// *******************************************************************************
// Tumbnail slider
// *******************************************************************************
const bottomSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  freeMode: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  on: {
    init(swiper) {
      setWrapperStyles(swiper);
    },
    resize(swiper) {
      setWrapperStyles(swiper);
    },
  },
};

bottomSliderElements.forEach((el) => {
  const bottomSliderParent = el.closest('.product-gallery__bottom');
  const arrowRight = bottomSliderParent.querySelector('.arrow-right');
  const arrowLeft = bottomSliderParent.querySelector('.arrow-left');

  bottomSliderOptions.navigation.nextEl = arrowRight;
  bottomSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-new
  new Swiper(el, bottomSliderOptions);
});

// *******************************************************************************
// Main slider
// *******************************************************************************
const topSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  thumbs: {
    swiper: false,
  },
};

topSliderElements.forEach((el, i) => {
  const topSliderParent = el.closest('.product-gallery__top');
  const arrowRight = topSliderParent.querySelector('.arrow-right');
  const arrowLeft = topSliderParent.querySelector('.arrow-left');

  topSliderOptions.navigation.nextEl = arrowRight;
  topSliderOptions.navigation.prevEl = arrowLeft;
  topSliderOptions.thumbs.swiper = bottomSliderElements[i].swiper;

  // eslint-disable-next-line no-new
  new Swiper(el, topSliderOptions);
});
